import { useAuth } from "../contexts/AuthContext";

/**
 * Helper for checking roles on the current user's profile.
 *
 * Roles are stored as a string array on the UserProfile document
 * (see `UserProfile.roles`). Known roles include:
 *   - view_error_details: enables the ErrorToast stacktrace UI
 *   - manage_entities: can CRUD the entity library
 */
export function useUserRoles() {
  const { userProfile } = useAuth();
  const roles = userProfile?.roles ?? [];

  const hasRole = (role: string): boolean => roles.includes(role);

  const hasAnyRole = (candidates: readonly string[]): boolean =>
    candidates.some((role) => roles.includes(role));

  const hasAllRoles = (candidates: readonly string[]): boolean =>
    candidates.every((role) => roles.includes(role));

  return { roles, hasRole, hasAnyRole, hasAllRoles };
}
